export const createLanguageOption = (value, language) => ({
	key: value,
	children: [],
	value: {
		[language]: value.toUpperCase(),
	},
	disabled: false,
});
